import { isEqual } from "lodash";
import type { SourcingEventDto } from "../../../../../autogen/bff-api";

const DEADLINES_MEASURED_AGAINST_A_MINIMUM = ["eventData.bidSubmissionDeadline", "eventData.requestDeadline"] as const;

const deadlineMinimumInputs = (event: SourcingEventDto) => {
  const publicContext = event.eventContext.type === "Public" ? event.eventContext : null;
  return {
    regulation: publicContext?.regulation ?? null,
    foaPart: publicContext?.foaPart ?? null,
    procedureType: publicContext?.procedureType ?? null,
    accelerated: publicContext?.acceleratedProcedure === true,
    plannedAnnouncement: event.eventData.milestonePlan?.announcementDate ?? null,
    agreedWithCandidates: event.eventData.tenderDeadlineAgreedWithCandidates ?? null,
  };
};

export const deadlineRefusalsOutdatedBySave = (
  before: SourcingEventDto,
  after: SourcingEventDto,
): readonly string[] =>
  isEqual(deadlineMinimumInputs(before), deadlineMinimumInputs(after)) ? [] : DEADLINES_MEASURED_AGAINST_A_MINIMUM;

const END_DATE_REFUSAL = "eventData.contractDuration.endDate";

// The BFF validates the merged event before every save, so a saved fixed-dates period is always in order.
export const contractPeriodRefusalsOutdatedBySave = (): readonly string[] => [END_DATE_REFUSAL];

const DPS_ORDER_REFUSALS = [
  "publicContext.dpsScheme.validFrom",
  "publicContext.dpsScheme.validTo",
  "eventData.requestDeadline",
] as const;

const dpsOrderInputs = (event: SourcingEventDto) => ({
  scheme: event.eventContext.type === "Public" ? event.eventContext.dpsScheme ?? null : null,
  firstIntakeDeadline: event.eventData.requestDeadline ?? null,
});

export const dpsOrderRefusalsOutdatedBySave = (
  before: SourcingEventDto,
  after: SourcingEventDto,
): readonly string[] => (isEqual(dpsOrderInputs(before), dpsOrderInputs(after)) ? [] : DPS_ORDER_REFUSALS);

export const refusalsOutdatedBySave = (before: SourcingEventDto, after: SourcingEventDto): readonly string[] => [
  ...deadlineRefusalsOutdatedBySave(before, after),
  ...contractPeriodRefusalsOutdatedBySave(),
  ...dpsOrderRefusalsOutdatedBySave(before, after),
];
